<div *transloco="let t; read: 'private-header'"
  class="private-header content">
  <h2>{{ directoryName() }}</h2>

  <div>
    <accredible-icon icon="lock" />
    {{ t('private_directory') }}
  </div>
</div>